export enum VideoStatus {
  READY = "READY",
  TRANSCRIBING = "TRANSCRIBING",
  /**
   * Enqueued for transcription, not yet picked up. Presentation-equivalent to
   * TRANSCRIBING (the bodycam types.ts contract requires readers that
   * special-case TRANSCRIBING to treat QUEUED the same); the listing API
   * serves it raw, so the frontend must recognize it.
   */
  TRANSCRIPTION_QUEUED = "TRANSCRIPTION QUEUED",
  TRANSCRIPT_READY = "TRANSCRIPT READY",
  FETCHING = "FETCHING",
  COMPRESSING = "COMPRESSING",
  FAILED = "FAILED",
  // AI-filtered: the evidence-judge marked this video NOT_EVIDENCE so it was
  // never fetched. Surfaced so users can still choose to fetch & use it.
  NOT_EVIDENCE = "NOT_EVIDENCE",
}

export interface VideoData {
  title: string;
  /**
   * Absent while the file isn't in S3 yet (still fetching/compressing).
   * This — not status — is the anchor for "can this video be played".
   */
  videoUrl?: string;
  recordedOn: string;
  recordedBy?: string;
  uploadedOn: string;
  uploadedBy?: string;
  id: string;
  transcript: unknown;
  status: VideoStatus;
  fileType?: string;
}
